import { Box, IconButton, InputAdornment, Stack, TextField, Tooltip, Typography, Grid } from '@mui/material';
import { AgGridTable } from 'components/tables/AgGridTable';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { sortAndFilter } from 'components/tables/AgGridTable';
import { formatDate } from 'utilities/common';
import { formatTimestampToDate24Hours } from 'utilities/common';
import AngleRightIcon from 'common/customIcons/angle_right';
import { fetchWalletLogs } from '../../../redux/slices/member';
import SearchIcon from 'common/customIcons/search';
import { BorderColor, CloseRounded, Opacity } from '@mui/icons-material';
import { useDebounce } from 'hooks/useDebounce';
import MDButton from 'components/MDButton';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { openSnackbar } from '../../../redux/slices/common';
import { exportSlotData, fetchSlotLogs } from '../../../redux/slices/hyperwolf/settings';
import { openCustomModalDialog } from '../../../redux/slices/modalSlice';
import { formatTimeTo12HourCombine } from 'utilities/common';
import { convertTimeRange } from 'utilities/common';




export default function SlotLogs() {
    const dispatch = useDispatch();
    const { logsloading: loading, slotsLogs = {}, isLoading } = useSelector(state => state.hyperwolfSettings);
    const searchTermRef = useRef('');
    const mainGridApiRef = useRef('');
    const gridRefApi = useRef(null);
    const pageRef = useRef(0);
    const navigate = useNavigate()
    const { memberId } = useParams();
    const [searchTerm, setSearchTerm] = useState("");

    const columnDefs = [
        {
            headerName: 'Day',
            field: 'newChanges',
            suppressMenu: false,
            key: 'newChanges',
            minWidth: 150,
            cellRenderer: useCallback((props) => (
                props?.value?.day ?
                    props?.value?.day
                    : '-'
            ), []),
            sortable: false,

        },
        //  {
        //     headerName: 'Time Slot',
        //     field: 'newChanges',
        //     minWidth: 150,
        //     cellRenderer: useCallback((props) => (
        //         // props?.value ? formatTimestampToDate24Hours(props?.value) : '-'
        //         props?.value?.timeSlot ? props?.value?.timeSlot : '-'

        //     ), []),
        //     flex: 1.3,
        //     sortable: false
        // },
        {
            headerName: 'Time Slot',
            field: 'newChanges',
            minWidth: 150,
            cellRenderer: useCallback((props) => (
                // props?.value ? formatTimestampToDate24Hours(props?.value) : '-'
                props?.value?.timeSlot ? convertTimeRange(props?.value?.timeSlot) : '-'

            ), []),
            flex: 1.3,
            sortable: false
        },
        {
            headerName: 'User',
            field: 'updatedBy',
            minWidth: 150,
            cellRenderer: (props) => {
                return props?.value ? `${props?.value}` : '-';
            },
            flex: 1.3,
            sortable: false
        },
        {
            headerName: 'Action Type',
            field: 'newChanges',
            key: 'fullName',
            suppressMenu: false,
            cellRenderer: useCallback((props) => (
                props?.value?.actionType ? props?.value?.actionType : '-'

            ), []),
            minWidth: 150,
            sortable: false
        },
        {
            headerName: 'Field Changed',
            field: 'newChanges',
            suppressMenu: false,
            cellRenderer: useCallback((props) => (
                props?.value?.fieldChanged ? props?.value?.fieldChanged : '-'

            ), []),
            minWidth: 150,
            sortable: false,

        },
        {
            headerName: 'Old Value',
            field: 'newChanges',
            suppressMenu: false,
            cellRenderer: useCallback((props) => (
                props?.value?.oldValue ? props?.value?.fieldChanged === 'Overall Limit' ? props?.value?.oldValue : convertTimeRange(props?.value?.oldValue) : '-'
            ), []),
            minWidth: 150,
            sortable: false,
        },
        {
            headerName: 'New Value',
            field: 'newChanges',
            suppressMenu: false,
            cellRenderer: useCallback((props) => (
                props?.value?.newValue ? props?.value?.fieldChanged === 'Overall Limit' ? props?.value?.newValue : convertTimeRange(props?.value?.newValue) : "-"
            ), []),
            minWidth: 150,
            sortable: false,
        },
        {
            headerName: 'Time',
            field: 'createdDate',
            minWidth: 150,
            cellRenderer: useCallback((props) => (
                props?.value ? formatTimestampToDate24Hours(props?.value) : '-'
            ), []),
            flex: 1.3,
            sortable: false
        },
        {
            headerName: 'Action',
            field: 'newChanges',
            suppressMenu: false,
            cellRenderer: (props) => {
                return props?.value?.overallOrderLimit?.rollBack ? <MDButton
                    sx={{ minWidth: '92px', color: "#0163FF", borderColor: "#0163FF !important", opacity: "1 !important" }}
                    type='button'
                    variant='outlined'
                    size="small"
                    onClick={() =>
                        dispatch(openCustomModalDialog({
                            modal: 'SLOT_ROLLBACK_DATA',
                            modalData: {
                                data: props?.data,
                                dataHandler: dataHandler
                            }
                        }))
                    }
                >
                    Rollback
                </MDButton>
                    : ""
            },
            minWidth: 150,
            headerClass: 'left-aligned-cell-header',
            sortable: false,
            headerClass: 'right-aligned-cell-header',
            cellStyle: { textAlign: 'right', justifyContent: 'end' },
        },
    ];

    const dataHandler = () => {
        searchFn()
    }
    const getRows = async (params) => {
        gridRefApi.current = params;
        dispatch(fetchSlotLogs({ skip: pageRef.current, limit: 20, searchTerm: searchTermRef.current })).unwrap().then(res => {
            const { activityLogs, total } = res;

            params.successCallback([...activityLogs], total);
            pageRef.current = pageRef.current + 20;
        }).catch(() => { params.successCallback([], 0); });
    };

    const searchHandler = (searchValue) => {
        setSearchTerm(searchValue);
        searchTermRef.current = searchValue;
        handleSearch(searchValue);
        // Debounce the search callback
    };

    const handleSearch = useDebounce(() => {
        pageRef.current = 0;
        searchFn();
    }, 500);

    const searchFn = (value) => {
        const dataSource = {
            getRows: (params) => getRows(params, value) // Pass the current filter payload
        };
        if (mainGridApiRef.current) {
            mainGridApiRef.current.ensureIndexVisible(0, null);
            mainGridApiRef.current.setGridOption("datasource", dataSource);
        }
    };
    useEffect(() => {
        if (mainGridApiRef?.current) {
            if (loading) {
                mainGridApiRef.current.showLoadingOverlay();
            } else if (slotsLogs?.total === 0) {
                mainGridApiRef.current.showNoRowsOverlay();
            }
            else {
                mainGridApiRef.current.hideOverlay();
            }
        }
    }, [slotsLogs, loading]);

    const handleExport = () => {
        dispatch(exportSlotData())
            .unwrap()
            .then((res) => {
                showError(res?.message, "success");
            })
            .catch((err) => {
                showError(err?.message, "error");
            });
    }


    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    return (
        <Box p={{ xs: 2, sm: 3, lg: 4 }} pb={{ lg: 2 }}>
            <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" gap={2} mb={2}>
                <span onClick={() => navigate(-1)} className='cur-pointer'>
                    <Box display="flex" gap={1} alignItems="center" color='text.main' lineHeight={1}>
                        <AngleRightIcon fontSize="14px" />
                        <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                            Time Slot Management
                        </Typography>
                    </Box>
                </span>
            </Stack>

            <Box p={{ xs: 0 }}>
                <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={2}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='h4'>Activity</Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2}>
                            <TextField
                                className="custom-search-field"
                                placeholder="Search"
                                label=""
                                value={searchTerm}
                                onChange={(e) => searchHandler(e.target.value)}
                                sx={{ minWidth: "280px" }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <IconButton size="small">
                                                <SearchIcon width="18px" height="18px" />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    endAdornment:
                                        searchTerm?.length > 0 ? (
                                            <InputAdornment>
                                                <IconButton onClick={() => searchHandler("")} size="small">
                                                    <CloseRounded />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                }}
                            />
                            {/* <MDButton loading={isLoading} onClick={() => { handleExport(); }} style={{ textTransform: 'none', minWidth: '180px', borderRadius: '30px', minHeight: '40px' }}
                                startIcon={<FileDownloadOutlinedIcon fontSize='large' />}
                                variant='contained' color='primary'>
                                Get PDF
                            </MDButton> */}
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
            <AgGridTable col={columnDefs} getRows={getRows} mainGridApiRef={mainGridApiRef} pageRef={pageRef} isLoading={loading} style={{ height: '70vh' }} />
        </Box>
    );
}